export default "__VITE_ASSET__$8cb_VKO__"